import { render } from "./TransferRequestDetailsModal.vue?vue&type=template&id=269387fa&scoped=true"
import script from "./TransferRequestDetailsModal.vue?vue&type=script&lang=js"
export * from "./TransferRequestDetailsModal.vue?vue&type=script&lang=js"

import "./TransferRequestDetailsModal.vue?vue&type=style&index=0&id=269387fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-269387fa"]])

export default __exports__